import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import RouterApp from "./RouterApp";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const assetPath = `${process.env.PUBLIC_URL}/1000115788.png`;

root.render(
  <StrictMode>
    <RouterApp />
  </StrictMode>
);
